module.exports = __webpack_public_path__ + "img/pengiriman-gabungan.ef67b8ef.png";